<template>
    <div>
        <modal ref="modal" size="lg" :has-footer="false" @hide="close()">
            <div slot="title">Facebook Integration</div>

            <card-spinner
                v-if="loading"
                style="height: 200px;"
            />

            <div v-if="!loading">
                <div>
                    <p class="mb-2">
                        Choose the Facebook Page that you would like to integrate with our platform.
                        <span class="float-right">
                            <button type="button" @click="loadPages"
                                class="btn btn-default"
                                style="font-size: 12px; padding: 2px 8px">
                                <i class="fa fa-sync-alt mr-1"></i>
                                Refresh
                            </button>
                        </span>
                    </p>

                    <div class="row mb-4" v-if="pages.data.length">
                        <div v-for="page of pages.data" :key="page.id" class="col-6">
                            <div @click="select(page)" class="media facebook-page"
                                :class="{'selected': isSelected(page)}">
                                <img class="align-self-center mr-3"
                                    style="max-width: 60px"
                                    :src="page.picture.data.url">

                                <div class="media-body align-self-center">
                                    <div class="">
                                        <p class="page-name">
                                            <b>{{ page.name }}</b>
                                            <i class="float-right fa fa-check" style="font-size: 24px"></i>
                                        </p>

                                        <p class="page-address" v-if="page.single_line_address">
                                            {{ page.single_line_address }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!pages.data.length">
                        <div class="alert alert-warning mb-0">
                            Oops! It looks like you don't manage any facebook page. This integration is available only for facebook
                            users which can manage facebook pages.
                        </div>
                    </div>
                </div>

                <ul v-if="pages.paging" class="pagination justify-content-center mb-1">
                    <ul :class="'page-item' + (pages.paging.previous ? '' : ' disabled')">
                        <a class="page-link" :disabled='pages.paging.previous' @click="getPaginatedData(pages.paging.previous)"><i class="fa fa-angle-left"></i></a>
                    </ul>
                    <ul :class="'page-item' + (pages.paging.next ? '' : ' disabled')">
                        <a class="page-link" :disabled='pages.paging.next' @click="getPaginatedData(pages.paging.next)"><i class="fa fa-angle-right"></i></a>
                    </ul>
                </ul>
                <div v-if="pages.paging" class="text-center">
                    Showing {{ currentPages }} of {{ allPages }}
                </div>

                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button type="button" class="btn btn-default" @click="closeEdit()">
                        Cancel
                    </button>
                    <button type="button" @click="save()"
                        :disabled="loading || !selected_page"
                        class="btn btn-primary">
                        Save
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        userToken: {
            default: null
        },

        page: {
            default: null
        }
    },

    data() {
        return {
            selected_page: null,
            loading      : true,
            pages        : {},
            allPages     : 0,
            currentPages : 0,
        };
    },

    watch: {
        page() {
            if (this.page && this.page.page_id) {
                this.selected_page = {
                    id: this.page.page_id,
                    name: this.page.name,
                    picture: {
                        data: {
                            url: this.page.picture
                        }
                    },
                    access_token: this.page.token
                };
                return;
            }

            this.selected_page = this.page;
        }
    },

    methods: {
        async open() {
            this.$refs.modal.open();
            await this.getAllPages();
            this.loadPages();
        },

        close() {
            this.$emit('hide');
            this.selected_page = this.page;
        },

        closeEdit() {
            this.$refs.modal.close();
        },

        select(page) {
            this.selected_page = page;
            this.$emit("selected-page", this.selected_page);
        },

        save(page) {
            this.$emit('save', this.selected_page);
        },

        async getAllPages(){
            const fields = "id";
            const access_token = this.userToken;
            await FB.api(
                "/me/accounts",
                { fields, access_token },
                (response) => {
                    this.allPages = response.data.length;
                }
            );
        },

        loadPages() {
            this.loading       = true;
            this.pages         = {};
            this.allPages      = 0;
            this.currentPages  = 0;

            if (this.page) {
                this.selected_page = null;
            }

            const fields       = "id,name,single_line_address,access_token,picture.type(large)";
            const access_token = this.userToken;
            const limit        = 10;
            FB.api(
                "/me/accounts",
                { fields, access_token, limit },
                this.onLoadedPages.bind(this)
            );
        },

        onLoadedPages(response) {
            this.pages        = response || [];
            this.loading      = false;
            this.currentPages = this.pages.data.length;
        },
        
        isSelected(page) {
            return this.selected_page && this.selected_page.id === page.id;
        },

        getPaginatedData(link){
            FB.api(
                link,
                this.onLoadedPages.bind(this)
            );
        }
    }
};
</script>

<style lang="sass" scoped>
    $primary: #0374d7
    $light-grey: #e9ecef
    $effect-time: 0.15s
    .facebook-page
        background-color: white
        padding: 10px
        border-radius: 5px
        border: 1px solid $light-grey
        cursor: pointer
        transition: all $effect-time ease-in-out
        &:hover
            border-color: darken($light-grey, 10%)
        &.selected
            border-color: $primary
            .page-name
                color: $primary
            .page-name i
                opacity: 1
                transform: scale(1)
        .page-name
            margin: 0
            i
                transition: all $effect-time ease-in-out
                opacity: 0
                transform: scale(0)
        .page-address
            margin: 0
            font-size: 12px
    .page-item
        padding: 0
        color: #0374d7
</style>
